import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
  ViewRef,
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ITrip } from 'src/app/core/types/interfaces/popular-trip.interface';

import { TripsService } from 'src/app/core/services/trips.service';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';

import { PopularTripDialogComponent } from 'src/app/shared/dialogs/popular-trip-dialog/popular-trip-dialog.component';
import { GoogleAnalyticService } from '../../../core/services/google-analytic.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
    selector: 'app-trip-card',
    templateUrl: './trip-card.component.html',
    styleUrls: ['./trip-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxSkeletonLoaderModule]
})
export class TripCardComponent implements OnInit {
  @Input() trip: ITrip;
  @Input() showButtonAction = false;
  @Input() buttonText = 'Select';
  @Input() isFetching: boolean = false;

  readonly #matDialog: MatDialog = inject(MatDialog);

  constructor(
    private cloudinaryService: CloudinaryService,
    private tripsService: TripsService,
    private googleAnalyticService: GoogleAnalyticService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  get tripRange(): string {
    let range = '12';

    if (this.trip && this.trip.duration_range) {
      const separator = '-';
      range = this.trip.duration_range.replace(
        /(\s*to\s*)|(\s*\-\s*)/gi,
        separator,
      );
      const rangeArr = range.split(separator);

      if (rangeArr.length === 2 && rangeArr[0] === rangeArr[1]) {
        return rangeArr[0];
      }
    }

    return range;
  }

  ngOnInit(): void {
    if (this.isFetching) return;

    if (!this.trip.image_url.includes('cloudinary')) {
      this.trip.image_url = this.cloudinaryService.getCloudImage(
        this.trip.image_url,
        true,
        true,
      );
    }
    this.detectViewChanges();
  }

  openTripOverview(): void {
    const { tripData } = this.trip;
    this.googleAnalyticService.setPlaningTypeStripAnalytic({
      planing_type_strip: 'selected popular iteraries',
      userID: this.authService.userId,
    });
    const openDialogWithAdvanceInfo = (trip: ITrip) => {
      this.#matDialog.open(PopularTripDialogComponent, {
        width: '1324px',
        maxWidth: '96vw',
        data: {
          trip: trip,
        },
      });
    };

    if (!tripData) {
      this.tripsService
        .getTripByUrlName(this.trip.url)
        .subscribe((tripData) => {
          if (tripData) {
            const trip = { ...this.trip, tripData: tripData };
            openDialogWithAdvanceInfo(trip);
          }
        });
    } else {
      openDialogWithAdvanceInfo(this.trip);
    }
  }

  ignoreLink(ev: MouseEvent): boolean {
    ev.preventDefault();
    return false;
  }

  private detectViewChanges(): void {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }
}
